import { useLang } from "@/context/LanguageContext";
import { INSIGHTS } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export default function Insights() {
  const { t, lang } = useLang();

  return (
    <section
      id="insights"
      className="section-y bg-[color:var(--alabaster)]"
      data-testid="insights-section"
    >
      <div className="container-lux">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <div className="overline" data-testid="insights-overline">{t.insights.overline}</div>
            <h2
              className="mt-6 font-serif-display text-[clamp(2rem,4.5vw,3.75rem)] leading-[1.05] tracking-[-0.01em] text-[color:var(--anthracite)]"
              data-testid="insights-title"
            >
              {t.insights.title}
            </h2>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {INSIGHTS.map((post) => (
            <article
              key={post.id}
              className="group cursor-pointer"
              data-testid={`insight-${post.id}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-[color:var(--anthracite)]">
                <img
                  src={post.image}
                  alt={post.title[lang] || post.title.en}
                  className="img-cover img-zoom"
                  loading="lazy"
                />
              </div>
              <div className="mt-5">
                <div className="text-[10px] tracking-[0.28em] uppercase text-[color:var(--copper)]">
                  {(post.tag[lang] || post.tag.en) + " · " + post.date}
                </div>
                <h3 className="mt-3 font-serif-display text-[22px] leading-[1.25] text-[color:var(--anthracite)] group-hover:text-[color:var(--copper)] transition-colors duration-300">
                  {post.title[lang] || post.title.en}
                </h3>
                <div className="mt-4 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[color:var(--anthracite)]/60 group-hover:text-[color:var(--copper)] transition-colors">
                  {t.insights.read_more}
                  <ArrowUpRight size={14} strokeWidth={1} className="group-hover:rotate-45 transition-transform duration-500" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
